<template>
  <offer-sale-base :offer-sale="offerSale" :is-group="isGroup" type="points_offer_sales" :is-activable="isActivable">
    <template v-slot:line-1>
      <offer-sale-line :line-items="isGroup ? pointsItems : productInfoItems" />
    </template>

    <template v-slot:line-2>
      <offer-sale-line :line-items="isGroup ? minMaxItems : pointsItems">
        <user-consumption v-if="isGroup" :maximum-per-client="offerSale.maximum_per_client" :user-sale-consumption-amount="userSaleConsumptionAmountInGroup" />
      </offer-sale-line>
    </template>

    <template v-if="!isGroup" v-slot:line-3>
      <offer-sale-line :line-items="minMaxItems">
        <user-consumption :maximum-per-client="offerSale.maximum_per_client" :user-sale-consumption-amount="offerSale.user_sale_consumption_amount" />
      </offer-sale-line>
    </template>
  </offer-sale-base>
</template>

<script>
import OfferSaleBase from './OfferSaleBase.vue'
import OfferSaleLine from './OfferSaleLine.vue'
import UserConsumption from './UserConsumption.vue'

export default {
  name: 'PointsOfferSale',
  components: {
    OfferSaleBase,
    OfferSaleLine,
    UserConsumption,
  },
  props: {
    offerSale: {
      type: Object,
      required: true,
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isGroup() {
      return this.offerSale.points_offer_sales && this.offerSale.points_offer_sales.length > 0
    },
    userSaleConsumptionAmountInGroup() {
      return this.offerSale.points_offer_sales.reduce((acc, pointsOfferSale) => acc + pointsOfferSale.user_sale_consumption_amount, 0)
    },
    productInfoItems() {
      return [
        {
          label: 'SKU',
          value: this.offerSale.sku,
          format: 'text',
        },
        {
          label: 'EAN',
          value: this.offerSale.ean,
          format: 'text',
        },
      ]
    },
    pointsItems() {
      return [
        {
          label: 'Preço 1',
          value: this.offerSale.price,
          format: 'currency',
        },
        {
          label: 'Pontos',
          value: this.offerSale.additional_points_rate,
          format: 'percent',
        },
      ]
    },
    minMaxItems() {
      return [
        {
          label: 'Mín. CPF',
          value: this.offerSale.minimum_per_client,
          format: 'text',
        },
        {
          label: 'Máx. CPF',
          value: this.offerSale.maximum_per_client,
          format: 'text',
        },
      ]
    },
  },
}
</script>
